// services/genaiworker.js
import axios from "axios";

const genAiInstance = axios.create({
  baseURL: "https://nccamodule-genai-api-gilead.indegene.com",
  timeout: 35000,
});

// Add the same interceptor pattern as your main instance
genAiInstance.interceptors.request.use(
  function (config) {
    const token = window.localStorage.getItem("userToken");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    // config.headers["Content-Type"] = "application/json";
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add response interceptor if needed
genAiInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default genAiInstance;
